import { CommonPost } from "../../../../utils/CommonFetch";

export default {
    getRegisterSupplierDetails
};

async function getRegisterSupplierDetails(data) {
    var model = {
        fromDate: data.fromDate,
        toDate: data.toDate,
    };
    const response = await CommonPost('/api/NewSupplierRegisterDetailsReport/GetNewSupplierRegisterDetails', null, model);
    return response.data;
}